import { StandardButton } from '@/components/buttons/standard';
import { Logo } from '@/components/logo';
import { PrimaryLayout } from '@/layouts/primary';
import { Carousel } from '@mantine/carousel';
import { Box, Flex, Text, Title } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import styles from './styles.module.css';
import { SignupImage } from './welcome-image';

export const WelcomePage = () => {
	const navigate = useNavigate();

	const signupButton = useMemo(
		() => (
			<StandardButton variant="filled" onClick={() => navigate({ to: '/signup' })}>
				Sign Up
			</StandardButton>
		),
		[navigate]
	);
	const loginButton = useMemo(
		() => (
			<StandardButton variant="light" onClick={() => navigate({ to: '/auth/login' })}>
				Log In
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout footer={{ children: [signupButton, loginButton] }}>
			<Flex direction="column" align="center" justify="flex-start" h="100%" bg="white" flex={1}>
				<Flex
					direction="column"
					align="center"
					justify="flex-start"
					h="221px"
					className={styles.splash}
					pt="lg"
				>
					<Logo />
					<Box h="50px" />
					<Title order={1}>Welcome to Curby</Title>
				</Flex>
				<Flex direction="column" justify="center" align="center" flex={1} w="100%" pt="lg">
					<SignupImage width={'100%'} />

					<Carousel withIndicators withControls={false} height="100%" classNames={styles}>
						<Carousel.Slide>
							<Title order={2} mb="md">
								Curby
							</Title>

							<Text ta="center" size="sm" w="66%">
								The Curby program helps Aussies to keep hard to recycle materials such as soft
								plastics out of the environment. Through using special program bags that are placed
								in your yellow-lidded bin (where council-approved) or your nearest return-to-store
								drop-off point, and incentivising positive household recycling behaviour through the
								Curby rewards program.
							</Text>
						</Carousel.Slide>
						<Carousel.Slide>
							<Title order={2} mb="md">
								Curby Rewards
							</Title>

							<Text ta="center" size="sm" w="66%">
								The Curby Rewards program is Australia’s first and only customer loyalty program
								that rewards consumers for doing their part to recycle specific materials.
							</Text>
						</Carousel.Slide>
						<Carousel.Slide>
							<Title order={2} mb="md">
								How it works
							</Title>

							<Text ta="center" size="sm" w="66%">
								You earn entries to the Curby Rewards prize draw every time you scan and drop a
								CurbyBag into a yellow-lidded bin (where council-approved) or your nearest
								return-to-store drop-off point. So, the more you recycle the more chances you’ll
								have to win!
							</Text>
						</Carousel.Slide>
						<Carousel.Slide>
							<Text ta="center" size="sm" w="66%">
								To find out more about the Curby Program, click sign up below!
							</Text>
						</Carousel.Slide>
					</Carousel>
				</Flex>
			</Flex>
		</PrimaryLayout>
	);
};
